import { Component, Input } from '@angular/core';
import { usuarioAtivo, usuarioInativo } from '../../usuario-situacao';

/** Componente para exibir o badge da situação do usuário */
@Component({
  selector: 'sgt-usuario-badge-situacao',
  templateUrl: './badge-situacao.component.html',
})
export class UsuarioBadgeSituacaoComponent {
  /** Situação do usuário */
  @Input() situacao: number;

  /** Usuário ativo */
  usuarioAtivo = usuarioAtivo;
  /** Usuário inativo */
  usuarioInativo = usuarioInativo;
}
